__turbopack_context__.v({
  "file-library-item-in": "file-library-graphic-module__BoQoCW__file-library-item-in",
  "folderBack": "file-library-graphic-module__BoQoCW__folderBack",
  "folderButton": "file-library-graphic-module__BoQoCW__folderButton",
  "folderFlap": "file-library-graphic-module__BoQoCW__folderFlap",
  "folderLabel": "file-library-graphic-module__BoQoCW__folderLabel",
  "folderPaper": "file-library-graphic-module__BoQoCW__folderPaper",
  "folderScene": "file-library-graphic-module__BoQoCW__folderScene",
  "item0": "file-library-graphic-module__BoQoCW__item0",
  "item1": "file-library-graphic-module__BoQoCW__item1",
  "item2": "file-library-graphic-module__BoQoCW__item2",
  "item3": "file-library-graphic-module__BoQoCW__item3",
  "paperLines": "file-library-graphic-module__BoQoCW__paperLines",
  "paperTitle": "file-library-graphic-module__BoQoCW__paperTitle",
});
